// extracted by mini-css-extract-plugin
module.exports = {"iframe":"LatestVideo_iframe__3dIwI"};